import { DateTime } from 'luxon';
import {
  ProductPricing,
  productPricingFromResponse,
  productPricingToUpsertRequest,
} from '../Product/ProductPricing';
import {
  ProductOptionKVP,
  productOptionKVPFromResponse,
  productOptionKVPToUpsertRequest,
} from './ProductOptionKVP';
import { Product } from '../Product/Product';

export interface ProductOption {
  quantity: number;
  imagePath?: string;
  barcode?: string;
  sku?: string;
  hepsiburada_sku?: string;
  basePrice: number;
  pricing: ProductPricing;
  position: number;
  expiryDate?: Date;
  isActive: boolean;
  kvps: ProductOptionKVP[];
}

export const productOptionFromResponse = (
  responseData: any,
): ProductOption => ({
  quantity: responseData.quantity,
  imagePath: responseData.image_path,
  barcode: responseData.barcode,
  sku: responseData.sku,
  hepsiburada_sku: responseData.hepsiburada_sku,
  basePrice: (responseData.base_price ?? 0) / 100,
  pricing: productPricingFromResponse(responseData.pricing),
  position: responseData.position,
  expiryDate: responseData.expiry_date
    ? new Date(responseData.expiry_date)
    : undefined,
  isActive: responseData.is_active,
  kvps: (responseData.key_and_value_names ?? []).map((kvp: any) =>
    productOptionKVPFromResponse(kvp),
  ),
});

export const productOptionFromProduct = (
  product: Product,
  position: number,
  kvps: ProductOptionKVP[],
): ProductOption => ({
  quantity: 0,
  basePrice: product.basePrice,
  pricing: product.pricing,
  position,
  expiryDate: product.expiryDate,
  isActive: true,
  kvps,
});

export const productOptionToUpsertRequest = (productOption: ProductOption) => ({
  quantity: productOption.quantity,
  image_path: productOption.imagePath,
  barcode: productOption.barcode,
  sku: productOption.sku,
  hepsiburada_sku: productOption.hepsiburada_sku,
  base_price: Math.round(productOption.basePrice * 100),
  pricing: productPricingToUpsertRequest(productOption.pricing),
  position: productOption.position,
  expiry_date: productOption.expiryDate
    ? DateTime.fromJSDate(productOption.expiryDate)
        .startOf('day')
        .setZone('utc', { keepLocalTime: true })
        .toISO({ suppressMilliseconds: true })
    : undefined,
  is_active: productOption.isActive,
  key_and_value_names: productOption.kvps.map((kvp) =>
    productOptionKVPToUpsertRequest(kvp),
  ),
});
